import { FeatureValue } from '../entities';
import { useFeatureFlags } from './useFeatureFlags';

export function useFeatureValue<T extends FeatureValue>(featureName: string, defaultValue: T) {
  const featureFlags = useFeatureFlags();

  return featureFlags.getFeatureValue<T>(featureName, defaultValue);
}
